import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

Vue.use(Vuex)

const state = {
  wpdata: false,
  formSent: false,
  emailValid: false,
  addressComplete: false,
  showOffer: false,
  addressForm: {
    email: '',
    name: '',
    club: '',
    street: '',
    zip: '',
    city: '',
    country: 'DE',
    ust: '',
    phone: ''
  },
  selections: {
    selected_analyse: [],
    selected_camera: []
  },
  values: {
    price_streaming: 0,
    price_analyse: 0,
    price_camera: 0,
    term_discount: 0,
    term_month: 0,
    payment_discount: 0,
    payment_type: "",
    payment_type_name: ""
  },
  available: true,
  delivery_type: 'now',
  delivery_date: null,
  delivery_date_min: null,
  delivery_date_max: null
}

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})

if (module.hot) {
  module.hot.accept([
    './getters',
    './actions',
    './mutations'
  ], () => {
    store.hotUpdate({
      getters: require('./getters'),
      actions: require('./actions'),
      mutations: require('./mutations')
    })
  })
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js